import { all, call, put, takeLatest } from 'redux-saga/effects';
import { getData, post } from '../services/api';
import {
  getMultibrandWebView as GET_MULTIBRAND_WEB_VIEW,
  webViewMultibrandAttempt,
  webViewMultibrandFailed,
  webViewMultibrandSuccess,
} from '../actions';
import { MARKETING_CHANNEL_ID } from '../theme/theme.constants';
import { WEB_VIEW_TYPES } from '../constants';
import {
  CUSTOMER_API_TOKEN,
  POLICY_API_TOKEN,
  WEBVIEW_API_TOKEN,
} from '../services/constants';
import {
  usePetCloudCustomerV1T173084ForSagas,
} from '../services/featureFlagsForSagas';

function* getWebViewUrl({
  coveragePeriodId = 0,
  companyId = 0,
  dispatch,
  petId,
  policyId,
  policyNumber,
  webViewType = '',
}) {
  try {
    const isCustomerApi =
      yield usePetCloudCustomerV1T173084ForSagas();
    const api = isCustomerApi ? 'customer' : 'api';
    const url = `${api}/MultiBrand/WebView`;

    const WEBVIEW_WITH_SCOPES = [
      WEB_VIEW_TYPES.changeCoverage,
      WEB_VIEW_TYPES.paymentMethod,
    ];
    const CUSTOMER_SCOPE = 'customer';
    const POLICY_SCOPE = 'policy';

    const webViewToken = getData(WEBVIEW_API_TOKEN);

    const body = {
      CompanyId: String(companyId),
      Params: {},
      ScopeTokens: [],
      Token: webViewToken,
      WebViewType: webViewType,
    };

    if (policyId) {
      body.Params.PolicyId = String(policyId);
    }
    if (petId) {
      body.Params.PetId = String(petId);
    }
    if (policyNumber) {
      body.Params.PolicyNumber = String(policyNumber);
    }

    // for Orca webviews only
    if (coveragePeriodId && companyId !== MARKETING_CHANNEL_ID.figo) {
      body.Params.CoveragePeriodId = coveragePeriodId;
    }

    if (WEBVIEW_WITH_SCOPES.includes(webViewType)) {
      const policyToken = getData(POLICY_API_TOKEN);
      const customerToken = getData(CUSTOMER_API_TOKEN);

      body.ScopeTokens = [{
        Scope: CUSTOMER_SCOPE,
        Token: customerToken,
      }, {
        Scope: POLICY_SCOPE,
        Token: policyToken,
      }];
    }

    const response = yield call(post, dispatch, url, body);

    return response;
  } catch (_) {
    return null;
  }
}

export function* getMultibrandWebView(dispatch, action) {
  yield put(webViewMultibrandAttempt());

  const {
    coveragePeriodId,
    companyId = MARKETING_CHANNEL_ID.figo,
    petId,
    policyId,
    policyNumber,
    webViewType = WEB_VIEW_TYPES.billingAndPayment,
  } = action.payload;

  const urlResponse = yield getWebViewUrl({
    companyId,
    coveragePeriodId,
    dispatch,
    petId,
    policyId,
    policyNumber,
    webViewType,
  });

  if (urlResponse && urlResponse.IsValid) {
    yield put(webViewMultibrandSuccess({
      data: urlResponse.Data,
      webViewType,
    }));
  } else {
    yield put(webViewMultibrandFailed());
  }
}

export function* multibrandSaga(store) {
  yield all([
    takeLatest(GET_MULTIBRAND_WEB_VIEW, getMultibrandWebView, store.dispatch),
  ]);
}
